<template>
  <div>
    <h1 class="faq__title">{{ getLocalization('FAQ SMS Bower') }}</h1>
    <div class="faq__filter">
      <div class="tags">
        <div v-for="(category, index) in this.categories" :key="index" @click="changeChecked(index)"
             :class="['tag-item', index === checkedIndex ? 'active' : '']">
          {{ getLocalization(category.title) }}
        </div>
      </div>
    </div>
    <div class="faq__items" v-if="checkedIndex === index" v-for="(category, index) in this.categories">
      <div v-for="(answer, index) in category.content" :id="category.id">
        <div class="faq-card">
          <div class="faq-card__head" data-bs-toggle="collapse" aria-expanded="false"
               :aria-controls="'#collapse' + category.id + index"
               :data-bs-target="'#collapse' + category.id + index">
            <div class="--text">
              {{ getLocalization(answer.title) }}
            </div>
            <div class="--icon collapsed" data-bs-toggle="collapse"
                 :data-bs-target="'#collapse' + category.id + index"
                 aria-expanded="false"
                 :aria-controls="'#collapse' + category.id + index"></div>
          </div>
          <div :id="'collapse' + category.id + index" class="collapse faq-card__body">
            <div v-html="getLocalization(answer.body)"></div>
          </div>
        </div>
      </div>
    </div>

  </div>
</template>

<script>

export default {
  name: "faq",
  props: ['categories'],
  mounted() {
    this.filteredList = this.categories[this.checkedIndex]['content']
  },
  data() {
    return {
      checkedIndex: 0,
      filteredList: [],
    }
  },
  methods: {
    changeChecked(index) {
      this.checkedIndex = index;
      this.filteredList = this.categories[index]['content'];
    }
  }
}
</script>
